import React from 'react';
import { markCountedWeeks } from '../utils/pingolfScoring';
import './PinGolfStandingsTable.css';
import { personName } from '../utils/personName';

const displayName = personName;

// Season standings with a column per week. Shared by the League tab overview and the public
// season page so the two can't drift - they were showing the same data in two different
// shapes, and the week-by-week breakdown is the point of the board.
//
// Weeks a player's total didn't count are struck through: with best-N-of-M scoring the row
// deliberately doesn't sum to the total, and without marking them the table reads as broken.
// `flush` is for a container that has given up its own padding so the board can run the full
// width of the card - the table then supplies that inset itself, on the outer columns only, so
// the scroll region still spans edge to edge.
function PinGolfStandingsTable({ standings, weekCount, dropCount = 0, flush = false }) {
  const weekNumbers = Array.from({ length: weekCount }, (_, index) => index + 1);

  return (
    <>
      <div className={`pgs-table-scroll${flush ? ' pgs-table-scroll--flush' : ''}`}>
        <table className="pgs-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Player</th>
              {weekNumbers.map(weekNumber => <th key={weekNumber} className="pgs-week-col">W{weekNumber}</th>)}
              <th className="pgs-total-col">Total</th>
            </tr>
          </thead>
          <tbody>
            {standings.map(entry => {
              const weeklyPoints = entry.weeklyPoints || [];
              const counted = markCountedWeeks(weeklyPoints, weekCount, dropCount);
              return (
                <tr key={entry.userId}>
                  <td className="pgs-rank">{entry.rank}</td>
                  <td className="pgs-name">{displayName(entry)}</td>
                  {weekNumbers.map((weekNumber, index) => {
                    const points = weeklyPoints[index] || 0;
                    const dropped = points > 0 && !counted[index];
                    return (
                      <td
                        key={weekNumber}
                        className={`pgs-week-col${dropped ? ' is-dropped' : ''}`}
                        title={dropped ? 'Dropped week - not counted in the total' : undefined}
                      >
                        {points || '-'}
                      </td>
                    );
                  })}
                  <td className="pgs-total-col">{entry.seasonTotal}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {dropCount > 0 && (
        <p className={`pgs-note${flush ? ' pgs-note--flush' : ''}`}>
          Best {weekCount - dropCount} of {weekCount} weeks count. Struck-through weeks are dropped
          and not included in the total.
        </p>
      )}
    </>
  );
}

export default PinGolfStandingsTable;
